
export enum WidgetTypes
{
    Summary = 1,
    CurrentIssues = 2,
    StatusHistory = 3,
    SensorChart = 4,
    Production = 5,
    Weather = 6,
    SensorIcon = 7,
    MachineLearningPrediction = 8,
    PumpPerformanceCurves = 9
}
